import React from "react";
import { Input } from "@/components/ui/input";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "../fields/FieldWrapper";
import { UseFormRegister, Path } from "react-hook-form";

interface TextFieldProps<TFieldValues extends Record<string, any>> {
  register: UseFormRegister<TFieldValues>;
  name: Path<TFieldValues>;
  field: FormFieldType;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
}

export const TextField = <TFieldValues extends Record<string, any>>({
  register,
  name,
  field,
  required = false,
  readOnly = false,
  disabled = false,
}: TextFieldProps<TFieldValues>) => {
  return (
    <FieldWrapper element={field}>
      <Input
        id={name}
        placeholder={field?.placeholder || ""}
        className={`w-full ${readOnly ? "bg-gray-100" : ""}`}
        required={required}
        readOnly={readOnly || field?.readOnly}
        disabled={disabled}
        {...register(name)}
      />
    </FieldWrapper>
  );
};

export default TextField